/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestEventDto } from '../../models/harvest-event-dto';

export interface AddEvent_1$Params {
  harvestId: number;
      body: Array<HarvestEventDto>
}

export function addEvent_1(http: HttpClient, rootUrl: string, params: AddEvent_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestEventDto>>> {
  const rb = new RequestBuilder(rootUrl, addEvent_1.PATH, 'post');
  if (params) {
    rb.path('harvestId', params.harvestId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HarvestEventDto>>;
    })
  );
}

addEvent_1.PATH = '/api/harvests/{harvestId}/event';
